<template>
  <div class="wrapper">
    <div style="margin-top: 20px">
      <el-table :data="tableData" border show-overflow-tooltip style="width: 100%">
        <el-table-column align="center" prop="productName" label="服务项目"/>
        <el-table-column align="center" prop="pubUserName" label="联系人"/>
        <el-table-column align="center" prop="userPhone" label="联系方式"/>
        <el-table-column align="center" prop="requirement" label="服务信息"/>
        <el-table-column align="center" prop="category" label="图片">
          <template slot-scope="{row}">
            <CustomPic v-if="row.pictureList != null" :src="row.pictureList[0].url" :src-list="row.pictureListArray"/>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="address" label="服务地址"/>
        <el-table-column align="center" prop="totalAmount" label="合计金额（元）"/>
        <el-table-column align="center" prop="expectServiceTime" label="上门时间"/>
        <el-table-column align="center" prop="totalDuration" label="时长（小时）"/>
        <el-table-column align="center" prop="state" label="状态">
          <template slot-scope="{row}">
            <div style="color: #F09932;" v-if="row.state === 1">未处理</div>
            <div style="color: #2EBC21;" v-if="row.state === 2">已处理</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="processResult" label="处理结果"/>
        <el-table-column align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editClick(scope.row)">处理</el-button>
            <el-button type="text" size="small" @click="delproduct(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="page">
      <vxe-pager
        :current-page.sync="tablePage.currentPage"
        :page-size.sync="tablePage.pageSize"
        :page-sizes="tablePage.pageSizes"
        :total="tablePage.totalResult"
        :layouts="layouts"
        @page-change="pageChange"
      />
    </div>

    <el-dialog title="处理" :visible.sync="dialogFormVisible" :show-close="false"
               :close-on-click-modal="false">
      <el-form :model="form" label-position="left">
        <el-input type="textarea" rows="6" v-model="form.processResult" placeholder="请填处理结果" autocomplete="off"/>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="()=>{dialogFormVisible = false,form={}}">取 消
        </el-button>
        <el-button type="primary" @click="addOrEdit()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import UploadImg from '@/components/UploadImg.vue'
import axios from 'axios'
import api from '@/store/API/api'
import { default as CustomTemplate } from '@/components/CustomList/CustomTemplate'

export default {
  components: {
    UploadImg, ...CustomTemplate
  },
  data() {
    return {
      btndisabled: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      chooseId: '',
      form: {
        id: '',
        processResult: '',
      },
      pictureList: [],
      qualityInspectReportList: [],
      fileData: null,
      fileName: '',
      importVisible: false,
      uploadLoading: false,
      tableData: [],
      // ismore:false,
      tablePage: {
        totalResult: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'left',
        pageSizes: [10, 20, 50, 100, 500, 1000],
        perfect: true
      }
    }
  },
  created() {
    this.getLists()
  },
  computed: {
    ...mapState([
      'layouts'
    ])
  },
  methods: {
    ...mapActions([
      'serviceOrderList',
      'serviceOrderDel',
      'serviceOrderHandel'
    ]),
    onBeforeImg(data) {
      this.form.pictures = data.join(',')
    },
    onAfterImg(data) {
      this.form.qualityInspectReports = data.join(',')
    },
    // 分页功能
    pageChange(item) {
      if (item.type === 'size') {
        this.tablePage.currentPage = 1
      } else {
        this.tablePage.currentPage = item.currentPage
      }
      this.getLists()
    },
    // 查询列表
    getLists() {
      const params = {
        onlyCurrPubUser: false,
        pageNum: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize
      }
      this.serviceOrderList(params).then(res => {
        if (res.code === 200) {
          res.data.dataList.forEach(item => {
            const pictureListArray = []
            if (item.pictureList != null) {
              item.pictureList.forEach(picture => {
                pictureListArray.push(picture.url)
              })
            }
            item.pictureListArray = pictureListArray
          })
          this.tableData = res.data.dataList
          this.tablePage.totalResult = res.data.total
        }
      })
    },
    // 删除
    delproduct(row) {
      this.$XModal.confirm('您确定要删除该数据?').then(type => {
        if (type === 'confirm') {
          const params = row.id
          this.serviceOrderDel(params).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.getLists()
            }
          })
        } else {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        }
      })
    },
    editClick(row) {
      this.form.id = row.id
      this.form.processResult = ''
      this.dialogFormVisible = true
    },
    addOrEdit() {
      this.serviceOrderHandel(this.form).then(res => {
        if (res.code === 200) {
          this.$message.success('修改成功')
          this.form.id = ''
          this.form.processResult = ''
          this.dialogFormVisible = false
          this.getLists()
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.wrapper {
  overflow: auto;

  .page {
    overflow: initial;
  }
}

.w-100 {
  width: 100% !important;
}

v-deep .el-form-item__label {
  text-align: left !important;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
